@if (loader) {
<app-loading></app-loading>
}
<div class="page">
  <div class="page-header">
    <div class="row align-items-center">
      <div class="col">
        <h3 class="page-title">Adjustments/Arrears</h3>
      </div>
      <div class="col-auto float-end ms-auto">
        <a
          class="btn add-btn"
          routerLink="/layout/payroll/adjustments-arrears-list"
          ><i class="fa fa-chevron-left"></i> Go Back
        </a>
      </div>
    </div>
  </div>

  <div class="content container-fluid">
    <div class="row" style="padding: 5px; margin-top: -15px">
      <div class="alert alert-primary" role="alert">
        NOTE : This page can be used for adjusting existing payroll or to add
        arrears to the existing payroll
      </div>
    </div>
    <div id="stepper2" class="bs-stepper">
      <div class="bs-stepper-header">
        <div id="step1" class="step" data-target="#test-l-1">
          <button class="step-trigger">
            <span class="bs-stepper-circle">1</span>
            <span class="bs-stepper-label">Select Employees & Reason</span>
          </button>
        </div>
        <div class="line"></div>
        <div id="step2" class="step" data-target="#test-l-2">
          <button class="step-trigger">
            <span class="bs-stepper-circle">2</span>
            <span class="bs-stepper-label">Apply Adjustments</span>
          </button>
        </div>
      </div>
      <div class="bs-stepper-content">
        <div id="test-l-1" class="content">
          <div class="row" style="padding: 5px; margin-top: -15px">
            <div class="alert alert-primary" role="alert">
              NOTE : Select Employees for which adjustments/arrears to be
              calculated
            </div>
          </div>

          <form nz-form [formGroup]="searchEmployeeForm">
            <div nz-row [nzGutter]="24">
              <!-- <div nz-col [nzSpan]="3">
            <div class="inptLbl"> Asset Department&nbsp;<span class="impFld">*</span></div>
            <nz-select style="width:100%;" nzPlaceHolder="" formControlName="dprt_id"
              (ngModelChange)="dprt_id()">
              <nz-option [value]="0">All</nz-option>

              <nz-option *ngFor="let d of categories" [nzValue]="d.dprt_id" [nzLabel]="d.dprt_nm">
              </nz-option>

            </nz-select>
          </div> -->

              <div nz-col [nzSpan]="3">
                <div class="inptLbl">
                  Department&nbsp;<span class="impFld">*</span>
                </div>
                <nz-select
                  style="width: 100%"
                  nzPlaceHolder=""
                  formControlName="dprt_id"
                >
                  <nz-option [value]="0">All</nz-option>
                  @for (d of dprt_lst; track d) {
                  <nz-option [nzValue]="d.dprt_id" [nzLabel]="d.dprt_nm">
                  </nz-option>
                  }
                </nz-select>
              </div>

              <!-- <div class="col-sm-3">
          <div class="form-group">
            <label class="col-form-label">Department <span class="text-danger">*</span></label>
            <select class="form-select floating form-control" formControlName="dprt_id"
              (change)="getSubDprt()">
              <option value="0">All</option>
              <option *ngFor="let d of dprt_lst" [value]="d.dprt_id">{{d.dprt_nm}}</option>
            </select>
          </div>
        </div> -->

              <div nz-col [nzSpan]="3">
                <div class="inptLbl">
                  Sub Department&nbsp;<span class="impFld">*</span>
                </div>
                <nz-select
                  style="width: 100%"
                  nzPlaceHolder=""
                  formControlName="sb_dprt_id"
                >
                  <nz-option [value]="0">All</nz-option>
                  @for (d of sbDprtLst; track d) {
                  <nz-option [nzValue]="d.dprt_id" [nzLabel]="d.dprt_nm">
                  </nz-option>
                  }
                </nz-select>
              </div>

              <div nz-col [nzSpan]="3">
                <div class="inptLbl">
                  Organization&nbsp;<span class="impFld">*</span>
                </div>
                <nz-select
                  style="width: 100%"
                  nzPlaceHolder=""
                  formControlName="orgn_id"
                >
                  <nz-option [value]="0">All</nz-option>
                  @for (d of orgnLst; track d) {
                  <nz-option [nzValue]="d.orgn_id" [nzLabel]="d.orgn_nm">
                  </nz-option>
                  }
                </nz-select>
              </div>

              <div nz-col [nzSpan]="3">
                <div class="inptLbl">
                  Designation&nbsp;<span class="impFld">*</span>
                </div>
                <nz-select
                  style="width: 100%"
                  nzPlaceHolder=""
                  formControlName="dsgns_id"
                >
                  <nz-option [value]="0">All</nz-option>
                  @for (d of dsgnsLst; track d) {
                  <nz-option [nzValue]="d.dsgns_id" [nzLabel]="d.dsgns_nm">
                  </nz-option>
                  }
                </nz-select>
              </div>

              <div nz-col [nzSpan]="3">
                <div class="inptLbl">
                  Employee Category &nbsp;<span class="impFld">*</span>
                </div>
                <nz-select
                  style="width: 100%"
                  nzPlaceHolder=""
                  formControlName="emple_ctgry_id"
                >
                  <nz-option [value]="0">All</nz-option>
                  @for (d of empleCatLst; track d) {
                  <nz-option
                    [nzValue]="d.emple_ctgry_id"
                    [nzLabel]="d.emple_ctgry_nm"
                  >
                  </nz-option>
                  }
                </nz-select>
              </div>
              <div nz-col [nzSpan]="3">
                <div class="inptLbl">
                  Employee Status &nbsp;<span class="impFld">*</span>
                </div>
                <nz-select
                  style="width: 100%"
                  nzPlaceHolder=""
                  formControlName="emple_sts_id"
                >
                  <nz-option [value]="0">All</nz-option>
                  @for (d of emplySts; track d) {
                  <nz-option
                    [nzValue]="d.emple_sts_id"
                    [nzLabel]="d.emple_sts_nm"
                  >
                  </nz-option>
                  }
                </nz-select>
              </div>

              <div class="col-sm-2" style="margin-top: 30px">
                <button
                  nz-button
                  style="margin-right: 8px"
                  (click)="getEmployees()"
                  [disabled]="loader"
                  nzType="primary"
                  nzDanger
                >
                  @if (loader) {
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  } @if (loader) {
                  <span class="sr-only">Loading...</span>
                  } Get Data
                </button>
              </div>
            </div>
          </form>

          @if (emplysMstr.length) {
          <div class="row" style="margin: 10px">
            <div class="col-sm-4">
              Total Employees Count : {{ emplysMstr.length || 0 }}
            </div>
            <div class="col-sm-4">
              Selected Employees Count : {{ selectEmployees.length || 0 }}
            </div>
          </div>
          } @if (emplysMstr.length) {
          <div id="data-grid-demo">
            <app-data-grid
              id="gridContainer"
              [dataSource]="emplysMstr"
              [legacyColumns]="columnDefs"
              [searchPanel]="true"
              [filterRow]="false"
              [filterPanel]="true"
              [groupPanel]="false"
              [columnChooser]="false"
              [allowExport]="false"
              [pageSize]="10"
              [allowedPageSizes]="[10, 25, 50, 100]"
              [showPageSizeSelector]="true"
              selectionMode="multiple"
              (selectionChanged)="selectionChanged($event)"
            >
            </app-data-grid>
          </div>
          } @if (emplysMstr.length) {
          <div class="row" style="margin-top: 40px">
            <div class="col-sm-3">
              <label class="col-form-label"
                >Select Reason For Adjustment<span class="text-danger"
                  >*</span
                ></label
              >
            </div>
            <div class="col-sm-7">
              <select
                class="form-select floating form-control"
                [(ngModel)]="adjsd_rsn_id"
              >
                @for (d of adjstmntsRsns; track d) {
                <option [value]="d.adjsd_rsn_id">{{ d.adjsd_rsn_nm }}</option>
                }
              </select>
            </div>
          </div>
          } @if (emplysMstr.length) {
          <div class="submit-section">
            <button
              class="btn btn-primary submit-btn"
              (click)="gotoComponentsSelection()"
              [disabled]="!selectEmployees.length || !adjsd_rsn_id"
            >
              Next
            </button>
          </div>
          }
        </div>
        <div id="test-l-2" class="content">
          <div class="alert alert-primary" role="alert">
            NOTE : Select Payroll Years & Months & Components for which
            adjustments/arrears to be calculated
          </div>
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group" style="margin-bottom: 0px">
                <label
                  class="col-form-label"
                  style="margin-top: -20px; margin-bottom: -23px"
                  >Select Payroll Years<span class="text-danger">*</span></label
                >
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" style="margin-bottom: 0px">
                <label
                  class="col-form-label"
                  style="margin-top: -20px; margin-bottom: -23px"
                  >Select Payroll Months<span class="text-danger"
                    >*</span
                  ></label
                >
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" style="margin-bottom: 0px">
                <label
                  class="col-form-label"
                  style="margin-top: -20px; margin-bottom: -23px"
                  >Select Allowances/Deductions<span class="text-danger"
                    >*</span
                  ></label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <!-- <ngx-bootstrap-multiselect class="multple_sel" style="background: white;border-radius: 5px;
                                border: 1px solid #e3e3e3;
                                padding-left: 3px;
                                padding-top: 10px;
                                padding-bottom: 6px;" [options]="years" [texts]="myTexts" [settings]="mySettings"
                [(ngModel)]="slctdyear">
              </ngx-bootstrap-multiselect> -->

                <nz-select
                  class="multple_sel"
                  [(ngModel)]="slctdyear"
                  [nzMode]="'multiple'"
                  [nzPlaceHolder]="myTexts.defaultTitle"
                  [nzShowSearch]="true"
                  [nzSearchPlaceholder]="myTexts.searchPlaceholder"
                  [nzNotFoundContent]="myTexts.searchEmptyResult"
                  style="
                    background: white;
                    border-radius: 5px;
                    border: 1px solid #e3e3e3;
                    padding: 10px 3px 6px;
                  "
                >
                  @for (year of years; track year) {
                  <nz-option [nzValue]="year.id" [nzLabel]="year.name">
                  </nz-option>
                  }
                </nz-select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <!-- <ngx-bootstrap-multiselect class="multple_sel" style="background: white;border-radius: 5px;
                                border: 1px solid #e3e3e3;
                                padding-left: 3px;
                                padding-top: 10px;
                                padding-bottom: 6px;" [options]="months" [texts]="myTexts" [settings]="mySettings"
              [(ngModel)]="slctdmnth">
            </ngx-bootstrap-multiselect> -->

                <nz-select
                  class="multple-sel"
                  [(ngModel)]="slctdmnth"
                  [nzMode]="'multiple'"
                  [nzPlaceHolder]="'Select months'"
                  [nzShowSearch]="true"
                  style="
                    background: white;
                    border-radius: 5px;
                    border: 1px solid #e3e3e3;
                    padding: 10px 3px 6px;
                  "
                >
                  @for (month of months; track month) {
                  <nz-option [nzValue]="month.id" [nzLabel]="month.name">
                  </nz-option>
                  }
                </nz-select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <ngx-bootstrap-multiselect
                  class="multple_sel"
                  style="
                    background: white;
                    border-radius: 5px;
                    border: 1px solid #e3e3e3;
                    padding-left: 3px;
                    padding-top: 10px;
                    padding-bottom: 6px;
                  "
                  [options]="cmpnts_lst"
                  [texts]="myTexts"
                  [settings]="mySettings"
                  [(ngModel)]="pyrle_cmpnt_ids"
                >
                </ngx-bootstrap-multiselect>
              </div>
            </div>
            <div class="col-sm-2" style="margin-top: -5px">
              <button
                class="btn btn-success w-100"
                (click)="getPayrollComponents()"
                [disabled]="loader"
              >
                @if (loader) {
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                } @if (loader) {
                <span class="sr-only">Loading...</span>
                } Get Data
              </button>
            </div>
          </div>
          @if (payroll_cmpnts.length) {
          <div id="data-grid-demo">
            <app-data-grid
              [headerFilter]="true"
              id="gridContainer"
              style="width: 100%"
              [dataSource]="payroll_cmpnts"
              [legacyColumns]="columnDefs1"
              [searchPanel]="true"
              [filterRow]="true"
              [filterPanel]="true"
              [groupPanel]="true"
              [columnChooser]="true"
              [allowExport]="false"
              [pageSize]="10"
              [allowedPageSizes]="[10, 25, 50, 100]"
              [showPageSizeSelector]="true"
              [rowAlternationEnabled]="true"
              [showBorders]="true"
              [masterDetail]="true"
            >
              <ng-template appGridDetail let-entCust="cell"
                ><div>
                  <app-data-grid
                    id="gridContainer"
                    [dataSource]="entCust.data.cmpnts_lst"
                    [legacyColumns]="columnDefs2"
                    [searchPanel]="false"
                    [filterRow]="false"
                    [filterPanel]="false"
                    [groupPanel]="false"
                    [columnChooser]="false"
                    [allowExport]="false"
                    [pageSize]="10"
                  >
                    <app-grid-column
                      dataField="cmpnt_type"
                      caption="Allowance/Deduction"
                      alignment="left"
                    ></app-grid-column>
                    <app-grid-column
                      dataField="pyrle_cmpnt_nm"
                      caption="Allowance/Deduction Name"
                      alignment="center"
                      filter="true"
                    ></app-grid-column>
                    <app-grid-column
                      dataField="pyrle_mnth"
                      caption="Payroll Month/Year"
                      alignment="center"
                      filter="true"
                    ></app-grid-column>
                    <app-grid-column
                      dataField="pyrle_cmpnt_at"
                      caption=" Existing Payroll Amount"
                      alignment="center"
                    ></app-grid-column>
                    <app-grid-column
                      [showInColumnChooser]="false"
                      [visible]="true"
                      type="buttons"
                      [width]="170"
                      caption="Updated Payroll Amount"
                      cellTemplate="timelineTemplate"
                    ></app-grid-column>
                    <ng-template appGridCell="timelineTemplate" let-data="cell"
                      ><div>
                        <input
                          type="number"
                          [(ngModel)]="data.data.updt_at"
                          (input)="calculate($event.target.value, data.data)"
                        /></div
                    ></ng-template>
                    <app-grid-column
                      [showInColumnChooser]="false"
                      [visible]="true"
                      type="buttons"
                      [width]="170"
                      caption="Adjusted Difference amount"
                      cellTemplate="AdjustedTemplate"
                    ></app-grid-column>
                    <ng-template appGridCell="AdjustedTemplate" let-data="cell"
                      ><div>
                        <input
                          type="number"
                          [(ngModel)]="data.data.ttl"
                          disabled
                        /></div
                    ></ng-template>
                  </app-data-grid></div
              ></ng-template>
            </app-data-grid>
          </div>
          } @if (payroll_cmpnts.length) {
          <div class="submit-section" (click)="applyAdjustment()">
            <button class="btn btn-primary submit-btn" [disabled]="loader">
              @if (loader) {
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              } @if (loader) {
              <span class="sr-only">Loading...</span>
              } Next
            </button>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
